// src/admin/components/AdminSidebar.jsx

import { NavLink } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";
const sections = [
  {
    title: "OVERVIEW",
    items: [
      {
        label: "Dashboard",
        path: "/admin/dashboard",
      },
    ],
  },

  {
    title: "CONTENT",
    items: [
      {
        label: "Posts",
        path: "/admin/posts",
      },
      {
        label: "Categories",
        path: "/admin/categories",
      },
      {
        label: "Tags",
        path: "/admin/tags",
      },
    ],
  },

  {
    title: "MARKETING",
    items: [
      {
        label: "Ad Banners",
        path: "/admin/banners",
      },
      {
        label: "Banner Analytics",
        path: "/admin/banner-analytics",
      },
      {
        label: "CTA Analytics",
        path: "/admin/cta-analytics",
      },
    ],
  },
  {
    title: "LIVE",
    items: [
      {
        label: "Live View",
        path: "/blog",
      },
    ],
  },

  {
    title: "SYSTEM",
    items: [
      {
        label: "Settings",
        path: "/admin/settings",
      },
    ],
  },
];

export default function AdminSidebar() {

  const { isDark } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate("/admin/login");
  };
  

  return (
    <aside
      className={`
        w-72
        h-screen
        sticky
        top-0
        border-r
        flex
        flex-col
        ${
          isDark
            ? "bg-black border-white/10"
            : "bg-white border-gray-200"
        }
      `}
    >
      {/* Logo */}

      <div
        className="
          px-6
          py-8
          border-b
          border-inherit
        "
      >
        <h1
          className="
            text-2xl
            font-bold
          "
        >
          DOROTS CMS
        </h1>

        <p
          className="
            text-sm
            text-gray-500
            mt-1
          "
        >
          Content Management
        </p>
      </div>

      {/* Navigation */}

      <div
        className="
          flex-1
          overflow-y-auto
          py-6
        "
      >
        {sections.map((section) => (
          <div
            key={section.title}
            className="mb-8"
          >
            <h3
              className="
                px-6
                mb-3
                text-xs
                font-semibold
                tracking-[0.2em]
                text-gray-500
              "
            >
              {section.title}
            </h3>

            <div className="space-y-1 px-3">

              {section.items.map((item) => (

                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `
                    block
                    px-4
                    py-3
                    rounded-xl
                    transition-all
                    ${
                      isActive
                        ? isDark
                          ? "bg-blue-800/20 text-blue-400"
                          : "bg-blue-50 text-blue-800"
                        : isDark
                          ? "hover:bg-white/5"
                          : "hover:bg-gray-100"
                    }
                  `
                  }
                >
                  {item.label}
                </NavLink>

              ))}

            </div>
          </div>
        ))}
      </div>

      {/* Footer */}

      <div
        className="
          p-6
          border-t
          border-inherit
        "
      >
        <div className="mb-4">

          <p className="font-medium">
            Admin User
          </p>

          <p
            className="
              text-sm
              text-gray-500
            "
          >
            Content Manager
          </p>

        </div>

        <button
          className="
            w-full
            py-3
            rounded-xl
            bg-red-500/10
            text-red-500
            hover:bg-red-500/20
            transition
          "
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </aside>
  );
}